import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { registerServiceWorker, installPushNavigationBridge, pushSupport } from "@/lib/webpush";
import { PushPermissionBanner } from "@/components/PushPermissionBanner";

/**
 * Bootstrap del sistema de Push Notifications:
 * - Registra el service worker tras carga inicial (idle callback).
 * - Instala el bridge para que un click en una notificación navegue en el SPA.
 * - Muestra el banner de permisos sólo cuando el usuario ya inició sesión
 *   (en mobile/iOS PWA esto significa que la app está instalada).
 */
export const PushBootstrap = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!pushSupport.serviceWorker) return;
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1200));
    const id = idle(() => { registerServiceWorker(); });
    return () => (window.cancelIdleCallback || clearTimeout)(id);
  }, []);

  useEffect(() => installPushNavigationBridge(navigate), [navigate]);

  return <PushPermissionBanner enabled={!loading && Boolean(user)} />;
};

export default PushBootstrap;
